import * as React from "react";
function SvgComponent(props) {
  return <svg {...props} width={54} height={55} fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M52.5 54C26.086 42.935 13.344 32.082 1 3m0 0v13M1 3l9.5 9" stroke="#fff" strokeWidth={2} strokeMiterlimit={4.134} strokeLinecap="round" /></svg>;
}
export default SvgComponent;